"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeRangeSelector = TimeRangeSelector;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _brockDateTime = require("brock-date-time");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _DeprecatedSingleSelect = require("./DeprecatedSingleSelect");

var _SingleSelect = require("./SingleSelect");

var _TimeRangeSelectorConstants = require("./TimeRangeSelectorConstants");

var _DateTimePicker = require("./DateTimePicker");

var _TypedInput = require("./TypedInput/TypedInput");

var _timeRangeSelectorUtils = require("./timeRangeSelectorUtils");

var _Label = require("../typography/Label");

var _Field = require("./Field");

var _Types = require("./TypedInput/Types");

var _TimeRangeSelectorShift = require("./TimeRangeSelectorShift");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DEFAULT_MIN = '1';
var DEFAULT_MAX = '9999'; // eslint-disable-next-line complexity

function isNumberInputValid(value, min, max) {
  return value !== undefined && value !== null && value !== '' && value >= min && value <= max;
} // eslint-disable-next-line max-statements


function TimeRangeSelector(props) {
  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      timeAndPrecision = _useState2[0],
      setTimeAndPrecision = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      timeAndPrecisionOptions = _useState4[0],
      setTimeAndPrecisionOptions = _useState4[1]; // eslint-disable-next-line max-statements, complexity


  (0, _react.useEffect)(function () {
    var _props$predefinedDate, _props$precisionTypeO, _props$previouslyUsed;

    var _props$timeAndPrecisi = props.timeAndPrecision,
        timeAndPrecisionType = _props$timeAndPrecisi.timeAndPrecisionType,
        predefinedDateRange = _props$timeAndPrecisi.predefinedDateRange,
        rangeType = _props$timeAndPrecisi.rangeType,
        previouslyUsedRange = _props$timeAndPrecisi.previouslyUsedRange;
    var builtTimeAndPrecisionOptions = (0, _timeRangeSelectorUtils.getTimeAndPrecisionOptions)(props.predefinedDateRangeOptions, props.timeAndPrecisionOptions, props.previouslyUsedRanges, props.labels);
    var builtTimeAndPrecision = {};

    if (!timeAndPrecisionType && builtTimeAndPrecisionOptions !== null && builtTimeAndPrecisionOptions !== void 0 && builtTimeAndPrecisionOptions.length) {
      builtTimeAndPrecision = _objectSpread(_objectSpread({}, builtTimeAndPrecision), {}, {
        timeAndPrecisionType: builtTimeAndPrecisionOptions[0].id
      });
    }

    if ((_props$predefinedDate = props.predefinedDateRangeOptions) !== null && _props$predefinedDate !== void 0 && _props$predefinedDate.length) {
      var _props$predefinedDate2;

      var selectedDateRangeOption = (_props$predefinedDate2 = props.predefinedDateRangeOptions.find(function (option) {
        return option.name === predefinedDateRange;
      })) !== null && _props$predefinedDate2 !== void 0 ? _props$predefinedDate2 : props.predefinedDateRangeOptions[0];
      builtTimeAndPrecision = _objectSpread(_objectSpread({}, builtTimeAndPrecision), {}, {
        predefinedDateRange: selectedDateRangeOption.name,
        selectedDateRangeOption: selectedDateRangeOption
      });
    }

    if ((_props$precisionTypeO = props.precisionTypeOptions) !== null && _props$precisionTypeO !== void 0 && _props$precisionTypeO.length && !rangeType) {
      builtTimeAndPrecision = _objectSpread(_objectSpread({}, builtTimeAndPrecision), {}, {
        rangeType: props.precisionTypeOptions[0]
      });
    }

    if (!previouslyUsedRange && (_props$previouslyUsed = props.previouslyUsedRanges) !== null && _props$previouslyUsed !== void 0 && _props$previouslyUsed.length) {
      var previouslyUsedOption = props.previouslyUsedRanges[0];

      var lastUsedStartDateTime = _brockDateTime.DateTimeFormatter.dateTime(previouslyUsedOption.startDateTime);

      var lastUsedEndDateTime = _brockDateTime.DateTimeFormatter.dateTime(previouslyUsedOption.endDateTime);

      var previouslyUsedSelectOption = {
        textField: "".concat(lastUsedStartDateTime, " - ").concat(lastUsedEndDateTime),
        valueField: previouslyUsedOption
      };
      builtTimeAndPrecision = {
        startDateTime: new Date(lastUsedStartDateTime),
        endDateTime: new Date(lastUsedEndDateTime),
        previouslyUsedRange: previouslyUsedSelectOption
      };
    }

    setTimeAndPrecision(_objectSpread(_objectSpread({}, props.timeAndPrecision), builtTimeAndPrecision));
    setTimeAndPrecisionOptions(builtTimeAndPrecisionOptions);
  }, [props.timeAndPrecision, props.timeAndPrecisionOptions, props.predefinedDateRangeOptions, props.previouslyUsedRanges, props.labels, props.precisionTypeOptions]);

  function handleDateTimeChange(propertyKey) {
    // eslint-disable-next-line max-statements, complexity
    return function (event) {
      if (timeAndPrecision.timeAndPrecisionType === _TimeRangeSelectorConstants.timeAndPrecisionTypes.fixedDay && propertyKey === _TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.startDateTime) {
        props.saveTimeAndPrecision(_objectSpread(_objectSpread({}, timeAndPrecision), {}, {
          startDateTime: event !== null && event !== void 0 ? event : undefined,
          endDateTime: event ? (0, _moment["default"])(event).add(1, 'days').toDate() : undefined
        }));
        return;
      }

      props.saveTimeAndPrecision(_objectSpread(_objectSpread({}, timeAndPrecision), {}, _defineProperty({}, propertyKey, event !== null && event !== void 0 ? event : undefined)));
    };
  }

  function handleSingleSelectChange(propertyKey) {
    // eslint-disable-next-line max-statements, complexity
    return function (selectedValue) {
      if (propertyKey === _TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.predefinedDateRange) {
        var _objectSpread3;

        var selectedDateRangeOption = props.predefinedDateRangeOptions.find(function (predefinedDateRangeOption) {
          return predefinedDateRangeOption.name === selectedValue;
        });
        props.saveTimeAndPrecision(_objectSpread(_objectSpread({}, timeAndPrecision), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, propertyKey, selectedValue), _defineProperty(_objectSpread3, "selectedDateRangeOption", selectedDateRangeOption), _objectSpread3)));
        return;
      }

      if (propertyKey === _TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.selectedPreviousRange) {
        var _selectedValue$valueF = selectedValue.valueField,
            startDateTime = _selectedValue$valueF.startDateTime,
            endDateTime = _selectedValue$valueF.endDateTime;
        props.saveTimeAndPrecision(_objectSpread(_objectSpread({}, timeAndPrecision), {}, {
          startDateTime: new Date(startDateTime),
          endDateTime: new Date(endDateTime),
          previouslyUsedRange: selectedValue
        }));
        return;
      }

      props.saveTimeAndPrecision(_objectSpread(_objectSpread({}, timeAndPrecision), {}, _defineProperty({}, propertyKey, selectedValue)));
    };
  }

  function handleNumberInputChange(propertyKey) {
    // eslint-disable-next-line max-statements, complexity
    return function (event) {
      var eventValue = event;

      if (eventValue && eventValue < 1) {
        eventValue = 1;
      }

      if (eventValue && eventValue > 9999) {
        eventValue = 9999;
      }

      props.saveTimeAndPrecision(_objectSpread(_objectSpread({}, timeAndPrecision), {}, _defineProperty({}, propertyKey, eventValue)));
    };
  }

  function renderDay() {
    return /*#__PURE__*/_react["default"].createElement(_DateTimePicker.DateTimePicker, {
      disabled: props.disabled,
      time: false,
      value: (0, _moment["default"])(props.timeAndPrecision.startDateTime).toDate(),
      onChange: handleDateTimeChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.startDateTime),
      culture: props.culture
    });
  }

  function renderFixed() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DateTimePicker.DateTimePicker, {
      disabled: props.disabled,
      label: props.labels.startDate,
      value: props.timeAndPrecision.startDateTime,
      onChange: handleDateTimeChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.startDateTime),
      culture: props.culture
    }), /*#__PURE__*/_react["default"].createElement(_DateTimePicker.DateTimePicker, {
      disabled: props.disabled,
      label: props.labels.endDate,
      value: props.timeAndPrecision.endDateTime,
      onChange: handleDateTimeChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.endDateTime),
      culture: props.culture
    }));
  }

  function getRange() {
    var _props$timeAndPrecisi2;

    var range = (_props$timeAndPrecisi2 = props.timeAndPrecisionRangeDomains[props.timeAndPrecision.timeAndPrecisionType]) === null || _props$timeAndPrecisi2 === void 0 ? void 0 : _props$timeAndPrecisi2[timeAndPrecision.rangeType];
    return (0, _isEmpty["default"])(range) ? {
      max: DEFAULT_MAX,
      min: DEFAULT_MIN
    } : range;
  }

  function renderLastNext() {
    var precisionTypeOptions = props.precisionTypeOptions.map(function (precisionType) {
      return {
        id: precisionType,
        description: props.labels[precisionType]
      };
    });

    var _getRange = getRange(),
        min = _getRange.min,
        max = _getRange.max;

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TypedInput.TypedInput, {
      disabled: props.disabled,
      value: timeAndPrecision.rangeValue,
      onChange: handleNumberInputChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.rangeValue),
      min: DEFAULT_MIN,
      max: DEFAULT_MAX,
      placeholder: "".concat(min, " ").concat(props.labels.to, " ").concat(max),
      supplementalValidator: function supplementalValidator() {
        return isNumberInputValid(timeAndPrecision.rangeValue, min, max);
      },
      type: _Types.Types.Int32Positive
    }), /*#__PURE__*/_react["default"].createElement(_DeprecatedSingleSelect.DeprecatedSingleSelect, {
      disabled: props.disabled,
      isClearable: false,
      onChange: handleSingleSelectChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.rangeType),
      options: precisionTypeOptions,
      textField: "description",
      valueField: "id",
      value: timeAndPrecision.rangeType
    }));
  }

  function renderPredefined() {
    var options = props.predefinedDateRangeOptions.map(function (optionName) {
      var _props$labels$optionN;

      return {
        description: (_props$labels$optionN = props.labels[optionName.name]) !== null && _props$labels$optionN !== void 0 ? _props$labels$optionN : optionName.name,
        id: optionName.name
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DeprecatedSingleSelect.DeprecatedSingleSelect, {
      disabled: props.disabled,
      isClearable: false,
      onChange: handleSingleSelectChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.predefinedDateRange),
      options: options,
      textField: "description",
      valueField: "id",
      value: timeAndPrecision.predefinedDateRange
    }), props.predefinedDateString && /*#__PURE__*/_react["default"].createElement(_Field.Field, {
      disabled: props.disabled
    }, /*#__PURE__*/_react["default"].createElement(_Label.Label, null, props.predefinedDateString)));
  } // eslint-disable-next-line complexity


  function renderUsePrevious() {
    var _timeAndPrecision$pre;

    var options = props.previouslyUsedRanges.map(function (range) {
      var startDateTime = _brockDateTime.DateTimeFormatter.dateTime(range.startDateTime);

      var endDateTime = _brockDateTime.DateTimeFormatter.dateTime(range.endDateTime);

      return {
        textField: "".concat(startDateTime, " - ").concat(endDateTime),
        valueField: range
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_SingleSelect.SingleSelect, {
      cssClassModifiers: ['time-range'],
      disabled: props.disabled,
      isClearable: false,
      onChange: handleSingleSelectChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.selectedPreviousRange),
      options: options,
      textField: "textField",
      valueField: "valueField",
      value: (_timeAndPrecision$pre = timeAndPrecision.previouslyUsedRange) !== null && _timeAndPrecision$pre !== void 0 ? _timeAndPrecision$pre : options[0]
    });
  } // eslint-disable-next-line complexity


  function renderRangeConfig() {
    switch (timeAndPrecision.timeAndPrecisionType) {
      case _TimeRangeSelectorConstants.timeAndPrecisionTypes.fixedDay:
        {
          return renderDay();
        }

      case _TimeRangeSelectorConstants.timeAndPrecisionTypes.last:
      case _TimeRangeSelectorConstants.timeAndPrecisionTypes.next:
        {
          return renderLastNext();
        }

      case _TimeRangeSelectorConstants.timeAndPrecisionTypes.predefined:
        {
          return renderPredefined();
        }

      case _TimeRangeSelectorConstants.timeAndPrecisionTypes.usePrevious:
        {
          return renderUsePrevious();
        }

      default:
        {
          return renderFixed();
        }
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DeprecatedSingleSelect.DeprecatedSingleSelect, {
    disabled: props.disabled,
    isClearable: false,
    onChange: handleSingleSelectChange(_TimeRangeSelectorConstants.timeAndPrecisionConfigurationKeys.timeAndPrecisionType),
    options: timeAndPrecisionOptions,
    textField: "description",
    valueField: "id",
    value: timeAndPrecision.timeAndPrecisionType,
    label: props.predicateLabel
  }), renderRangeConfig(), /*#__PURE__*/_react["default"].createElement(_TimeRangeSelectorShift.TimeRangeSelectorShift, {
    disabled: props.disabled,
    timeRangeSelectorShiftTypeDefault: props.timeRangeSelectorShiftTypeDefault,
    timeRangeSelectorShiftTypeOptions: props.timeRangeSelectorShiftTypeOptions,
    useTimeRangeShifter: props.useTimeRangeShifter,
    timeAndPrecision: timeAndPrecision,
    saveTimeAndPrecision: props.saveTimeAndPrecision,
    labels: props.labels
  }));
}
/* eslint-disable react/no-unused-prop-types */


TimeRangeSelector.propTypes = {
  saveTimeAndPrecision: _propTypes["default"].func.isRequired,
  timeAndPrecision: _propTypes["default"].instanceOf(Object).isRequired,
  culture: _propTypes["default"].string,
  dateFormat: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  labels: _propTypes["default"].instanceOf(Object),
  precisionTypeOptions: _propTypes["default"].instanceOf(Array),
  predicateLabel: _propTypes["default"].node,
  predefinedDateRangeOptions: _propTypes["default"].instanceOf(Array),
  predefinedDateString: _propTypes["default"].string,
  previouslyUsedRanges: _propTypes["default"].instanceOf(Array),
  timeAndPrecisionOptions: _propTypes["default"].instanceOf(Array),
  timeAndPrecisionRangeDomains: _propTypes["default"].instanceOf(Object),
  timeRangeSelectorShiftTypeDefault: _propTypes["default"].string,
  timeRangeSelectorShiftTypeOptions: _propTypes["default"].instanceOf(Array),
  useTimeRangeShifter: _propTypes["default"].bool
};
TimeRangeSelector.defaultProps = {
  culture: 'en',
  dateFormat: _brockDateTime.DateTimeFormats.DATETIME_SECONDS,
  disabled: false,
  labels: {},
  precisionTypeOptions: [],
  predicateLabel: null,
  predefinedDateRangeOptions: [],
  predefinedDateString: '',
  previouslyUsedRanges: [],
  timeAndPrecisionOptions: [],
  timeAndPrecisionRangeDomains: {},
  timeRangeSelectorShiftTypeDefault: null,
  timeRangeSelectorShiftTypeOptions: [],
  useTimeRangeShifter: false
};